import { tns } from 'tiny-slider';

(function (Drupal, once) {

  Drupal.behaviors.paragraphProjectTicker = {
    attach: function (context, settings) {
      const project_tickers = once('paragraph-project-tickers', '.paragraph--type--project-ticker', context);

      project_tickers.forEach((project_tickerWrapper) => {
        const containerEl = project_tickerWrapper.querySelector('.ticker-items > .field__items');

        let tickerMaxCount = 1;
        let tickerAutoplay = false;
        let tickerNav = false;

        if (project_tickerWrapper.classList.contains('ticker-autoplay')) {
          tickerAutoplay = true;
        }

        if (project_tickerWrapper.classList.contains('ticker-nav')) {
          tickerNav = true;
        }

        if (project_tickerWrapper.classList.contains('ticker-count-1')) {
          tickerMaxCount = 1;
        }

        if (project_tickerWrapper.classList.contains('ticker-count-2')) {
          tickerMaxCount = 2;
        }

        if (project_tickerWrapper.classList.contains('ticker-count-3')) {
          tickerMaxCount = 3;
        }

        if (project_tickerWrapper.classList.contains('ticker-count-4')) {
          tickerMaxCount = 4;
        }

        if (project_tickerWrapper.classList.contains('ticker-count-6')) {
          tickerMaxCount = 6;
        }

        const ticker = new tns({
          container: containerEl,
          slideBy: "page",
          items: 1,
          autoplay: tickerAutoplay,
          gutter: 10,
          //autoHeight: true,
          autoplayButtonOutput: false,
          nav: tickerNav,
          navPosition: 'bottom',
          controlsText: ['', ''],
          controlsPosition: 'bottom',
          preventScrollOnTouch: 'auto',
          responsive: {
            1500: {
              items: tickerMaxCount
            },
            1000: {
              items: 2
            },
          }
        });

      });
    }
  }

}(Drupal, once));
